export default "__VITE_ASSET__468eaafb__"